import axios from "../utils/APIUtils";
import { DASHBOARD_API_PATHS } from "src/constants/urlPathAndQueryParams";
import { IFooterDataModel } from "src/models/IDashboardAPIModel";

export const getFooterData = async () => {
  return await axios
    .get<IFooterDataModel>(DASHBOARD_API_PATHS.footer)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      console.log("getFooterData API error", err);
      throw err;
    });
};

export const getReviewImmediately = async () => {
  return await axios
    .get<any>(DASHBOARD_API_PATHS.overview)
    .then((response) => {
     return response.data;
    })
    .catch((err) => {
      console.log("getReviewImmediately API error", err);
      throw err;
    });
};
